function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 24C.673 24 0 23.327 0 22.5V7.82a1.519 1.519 0 01.279-.872L4.793.628A1.504 1.504 0 016.014 0h11.971c.485 0 .941.235 1.222.628l4.514 6.32A1.525 1.525 0 0124 7.82V22.5c0 .827-.673 1.5-1.5 1.5h-21zM1 22.5a.5.5 0 00.5.5h21a.5.5 0 00.5-.5V8H1v14.5zM22.529 7l-4.135-5.791A.504.504 0 0017.986 1H12.5v6h10.029zM11.5 7V1H6.014a.502.502 0 00-.407.209L1.471 7H11.5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.001 21a1 1 0 01-1-1v-2a1 1 0 011-1h7a1 1 0 011 1v2a1 1 0 01-1 1h-7zm0-1h7v-2h-7v2z"
});

function SvgArtifact(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "artifact.38bce.svg";
export { SvgArtifact as ReactComponent };